// Accounting Cashiers Vuex

import state from './cashierStates.js'
import * as getters from './cashierGetters.js'
import * as mutations from './cashierMutations.js'
import * as actions from './cashierActions.js'

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}
